<app-navbar />

<main class="page-content w-full mx-auto px-6" [class.navbar-fixed]="!isNavbarExpanded()">
  <app-breadcrumb />
  <router-outlet />
</main>

<app-payment-handler />
